import styled from "styled-components";

export default styled.span`
  :before {
    content: "–";
  }
  color: #999;
`;
